var map = {
	"./active.svg": 86882,
	"./ban.svg": 89343,
	"./banned.svg": 22600,
	"./banned_grey.svg": 33010,
	"./deviceLost.svg": 30612,
	"./failure.svg": 93258,
	"./fraudSuspicion.svg": 87207,
	"./lock.svg": 66025,
	"./lock_grey.svg": 93109,
	"./locked.svg": 22182,
	"./locked_grey.svg": 55944,
	"./paymentDefault.svg": 38757,
	"./pending_active.svg": 37014,
	"./pending_banned.svg": 60996,
	"./pending_failure.svg": 70334,
	"./pending_lock.svg": 7173,
	"./pending_locked.svg": 82738,
	"./pending_transport.svg": 97087,
	"./transport.svg": 42923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13168;